import React from 'react';

import { EmptyState } from '@/components/atoms/EmptyState';
import { useTranslator } from '@/hooks/useTranslator';
import { VerificationResult } from '@/types/customerKYXVerification';

interface Props {
  readonly verificationResult: VerificationResult;
  readonly beneficiaryId: string | null;
}

const compactContainerStyles = {
  flex: 1,
  minHeight: 200,
  backgroundColor: 'custom.OffWhite',
  borderRadius: 2,
  px: 7,
};

export const NoCustomerActivityView: React.FC<Props> = (props: Props): React.ReactElement => {
  const { verificationResult, beneficiaryId } = props;
  const tr = useTranslator();

  const isVerificationIncomplete =
    verificationResult !== VerificationResult.APPROVED || !beneficiaryId;

  return (
    <EmptyState.Container sx={compactContainerStyles}>
      <EmptyState.Title variant="h7">{tr('NO_ACTIVITY_YET_TITLE')}</EmptyState.Title>
      <EmptyState.Message color="text.secondary">
        {isVerificationIncomplete
          ? tr('NO_CUSTOMER_ACTIVITY_VERIFICATION_INCOMPLETE')
          : tr('NO_ACTIVITY_YET_SUBTITLE')}
      </EmptyState.Message>
    </EmptyState.Container>
  );
};
